export const PROVIDER_COVER_GENIUS = 'cover_genius'
export const PROVIDER_NIB = 'nib'

export const PRODUCT_ID_COMPREHENSIVE = 'COMPREHENSIVE_TRIP_PROTECTION'
export const PRODUCT_ID_OVERSEA_MEDICAL = 'OVERSEAS_MEDICAL_AND_EVACUATION_PROTECTION'
export const PRODUCT_ID_CANCELLATION_AND_BAGGAGE = 'CANCELLATION_AND_BAGGAGE_PROTECTION'
export const PRODUCT_ID_NO_PROTECTION = 'NO_PROTECTION'
export const PRODUCT_ID_FULL_PROTECTION_CRUISE_DOMESTIC = 'FULL_PROTECTION_CRUISE_DOMESTIC'
export const PRODUCT_ID_FULL_PROTECTION_CRUISE = 'FULL_PROTECTION_CRUISE'
export const PRODUCT_ID_CUSTOMISE = 'CUSTOMISE_PROTECTION'
export const PRODUCT_ID_CUSTOMISE_DOMESTIC = 'CUSTOMISE_PROTECTION_DOMESTIC'
export const PRODUCT_ID_PASSPORT_CARD = 'PASSPORT_CARD_COMPREHENSIVE_TRAVEL_INSURANCE'
export const INSURANCE_TYPE_PASSPORT_CARD: App.InsuranceType = 'passport-card-insurance'
// UTM campaign that forces PassportCard as the sole checkout insurance option
// (non-production only). See isPassportCardInsuranceSupportedViaCampaign.
export const PASSPORT_CARD_UTM_CAMPAIGN = 'passportcard'
/**
 * Production rollout gate for PassportCard on standalone tours/cruises: enabled by
 * default everywhere else, but production traffic must arrive with
 * `utm_campaign=ONLINE_TOUR_CRUISE`. Compared lowercased.
 */
export const PASSPORT_CARD_TOURS_CRUISES_UTM_CAMPAIGN = 'online_tour_cruise'

// PassportCard is capped at 2 adults (18+) per policy. Shared source of truth for
// both the traveller-entry UI validation and the checkout eligibility gating.
export const PASSPORT_CARD_MAX_ADULTS = 2

// PassportCard Selling Point value used for online (non-agent) tour/cruise traffic.
// Sent to svc-insurance, which forwards it to PassportCard's proposals API.
export const PASSPORT_CARD_SELLING_POINT_ONLINE_TOUR_CRUISE = 'ONLINE_TOUR_CRUISE'

export const POLICY_ID_TRAVEL_MEDICAL_COVER: App.InsurancePolicyId = 'travel_medical_cover'
export const POLICY_ID_TRAVEL_PERSONAL_BAGGAGE: App.InsurancePolicyId = 'travel_personal_baggage'

/** These insurance product ids are used for the 'customised' options  */
export const CustomisableProductIds = new Set([PRODUCT_ID_CUSTOMISE, PRODUCT_ID_CUSTOMISE_DOMESTIC])

export const INSURANCE_CANCELLATION_REASON_UPGRADED = 'insurance_upgraded'

export const CRUISE_INSURANCE_LIMIT_AGE = 80

export const CUSTOM_AMOUNT_COVERAGE_OPTIONS = [1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000]

export const INSURANCE_PRODUCT_ID = {
  CFMR: 'CFMR',
} as const

export const INSURANCE_PRODUCT_TYPE = {
  BOOKING_PROTECTION: 'booking-protection',
  INSURANCE: 'travel-insurance',
} as const
